document.addEventListener('DOMContentLoaded', () => {
  const cartRoot = document.querySelector('.tf-cart-page');
  if (!cartRoot) return;

  /* ===============================
     CART ITEM UPDATES
  =============================== */

  const postChange = async (line, quantity) => {
    const res = await fetch('/cart/change.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify({ line, quantity })
    });

    if (!res.ok) throw new Error('Cart update failed');
    return res.json();
  };

  const refresh = () => window.location.reload();

  cartRoot.addEventListener('click', async (e) => {
    const itemEl = e.target.closest('.tf-cart-item');
    if (!itemEl) return;

    const line = Number(itemEl.dataset.line);
    const input = itemEl.querySelector('[data-qty-input]');
    const current = Number(input?.value || 0);

    // Remove item
    if (e.target.matches('[data-remove]')) {
      e.preventDefault();
      try {
        await postChange(line, 0);
        refresh();
      } catch (err) {
        console.error(err);
      }
      return;
    }

    // Decrease qty
    if (e.target.matches('[data-qty-minus]')) {
      e.preventDefault();
      const next = Math.max(0, current - 1);
      if (input) input.value = next;

      try {
        await postChange(line, next);
        refresh();
      } catch (err) {
        console.error(err);
      }
      return;
    }

    // Increase qty
    if (e.target.matches('[data-qty-plus]')) {
      e.preventDefault();
      const next = current + 1;
      if (input) input.value = next;

      try {
        await postChange(line, next);
        refresh();
      } catch (err) {
        console.error(err);
      }
    }
  });

  // Manual quantity input
  cartRoot.addEventListener('change', async (e) => {
    if (!e.target.matches('[data-qty-input]')) return;

    const itemEl = e.target.closest('.tf-cart-item');
    if (!itemEl) return;

    const line = Number(itemEl.dataset.line);
    const next = Math.max(0, Number(e.target.value || 0));

    try {
      await postChange(line, next);
      refresh();
    } catch (err) {
      console.error(err);
    }
  });

  /* ===============================
     PROMO CODE TOGGLE + APPLY (CLASS BASED)
  =============================== */

  const promoWrap   = cartRoot.querySelector('.tf-promo');
  const promoToggle = cartRoot.querySelector('[data-promo-toggle]');
  const promoPanel  = cartRoot.querySelector('[data-promo-panel]');
  const promoInput  = cartRoot.querySelector('[data-promo-input]');
  const promoApply  = cartRoot.querySelector('[data-promo-apply]');

  // Ensure default closed (important if CSS/other scripts open it)
  if (promoWrap) promoWrap.classList.remove('is-open');

  if (promoToggle && promoWrap) {
    promoToggle.addEventListener('click', () => {
      promoWrap.classList.toggle('is-open');

      if (promoWrap.classList.contains('is-open')) {
        promoInput?.focus();
      }
    });
  }

  if (promoApply && promoInput) {
    promoApply.addEventListener('click', () => {
      const code = (promoInput.value || '').trim();
      if (!code) return;
      window.location.href = `/checkout?discount=${encodeURIComponent(code)}`;
    });
  }

  /* ===============================
     SHIPPING NOTE (IMPORTANT)
     Shopify does NOT give cart shipping price on cart page.
     So keep placeholder text in Liquid.

     If you want real shipping display:
     implement shipping estimator using /cart/shipping_rates.json
  =============================== */

  // const shippingDisplay = cartRoot.querySelector('[data-shipping-display]');
  // (optional estimator code can go here later)
});
